import { MIN_SLIDES, type QuoteCarousel, type QuoteSlide } from './types';

export type CarouselExportValidation =
  | { ok: true }
  | { ok: false; reason: 'too_few_slides' | 'empty_text' };

/** Gate shared by download and publish: at least MIN_SLIDES slides, and no
 *  slide with empty/whitespace-only text. */
export function validateCarouselForExport(carousel: QuoteCarousel): CarouselExportValidation {
  if (carousel.slides.length < MIN_SLIDES) return { ok: false, reason: 'too_few_slides' };
  if (carousel.slides.some((slide) => validateSlideForExport(slide).ok === false)) {
    return { ok: false, reason: 'empty_text' };
  }
  return { ok: true };
}

/** The same text rule for a single slide (single-image download). */
export function validateSlideForExport(slide: QuoteSlide): { ok: true } | { ok: false; reason: 'empty_text' } {
  return slide.text.trim() === '' ? { ok: false, reason: 'empty_text' } : { ok: true };
}
